import Vue from 'vue'
import VueI18n from 'vue-i18n'

import es from './es'
import pt from './pt'

var messages = {
	es,
	pt
}

Vue.use(VueI18n)

let locale = 'pt'

/*
let userLanguage = navigator.language || navigator.userLanguage

if( userLanguage.indexOf('pt') != -1 ){

	locale = 'pt'

}
*/

const i18n = new VueI18n({
	locale,
	fallbackLocale: 'pt',
	messages
})


export default i18n


// WEBPACK FOOTER //
// ./src/locales/i18n.js